'use client'

import React, { useContext, useEffect } from 'react'
import { SectionThemeContext } from '../../../contexts/SectionTheme.context'
import * as S from './Typography.styles'

interface TypographyProps {
  children?: React.ReactNode;
  content?: string;
  typo?: string;
  weight?: 'light' | 'regular' | 'medium' | 'semibold' | 'bold' | 'extraBold';
  textAlign?: 'center' | 'right' | 'left';
  colorScheme?: string;
  negative?: boolean;
  uppercase?: boolean;
  capitalize?: boolean;
  fontSecondary?: boolean;
  fontPrimary?: boolean;
  as?: React.ElementType;
  htmlFor?: string;
}

interface HeadingProps extends TypographyProps {
  underline?: boolean;
  id?: string;
}

const injectHtml = (children: React.ReactNode | string): { __html: string } => {
  return { __html: children as string };
};

const Heading: React.FC<HeadingProps> = ({ children, content, colorScheme, id, ...props }) => {
  const { selectedColorScheme = 'green' } = useContext(SectionThemeContext)

  return  (
    <S.Heading 
      {...props} 
      id={id}
      colorScheme={colorScheme || selectedColorScheme} 
      dangerouslySetInnerHTML={injectHtml(children ?? content)}
    />
  )
}

const Paragraph: React.FC<TypographyProps> = ({ children, content, colorScheme, ...props }) => {
  const { selectedColorScheme = 'green' } = useContext(SectionThemeContext)
  
  return (
    <S.Paragraph
      {...props}
      colorScheme={colorScheme || selectedColorScheme}
      dangerouslySetInnerHTML={{
        __html: children ? children as string : content as string,
      }} 
    />
  )
}

const Label: React.FC<TypographyProps> = ({ children, content, ...props }) => {
  const { selectedColorScheme = 'green' } = useContext(SectionThemeContext)

  return (
    <S.Label {...props} colorScheme={selectedColorScheme}>
      {children ?? content}
    </S.Label>
  )
}

const ButtonLabel: React.FC<TypographyProps> = ({ children, content, ...props }) => {
  const { selectedColorScheme = 'green' } = useContext(SectionThemeContext)

  return (
    <S.ButtonLabel {...props} colorScheme={selectedColorScheme}>
      {children ?? content}
    </S.ButtonLabel>
  )
}

export {
  Heading,
  Paragraph,
  Label,
  ButtonLabel
}
